var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDelete = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 20,
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 16.583q-.542 0-.938-.395-.395-.396-.395-.938V5.5h-1V4.417H8v-.896h4v.896h3.583V5.5h-1v9.729q0 .583-.385.969-.386.385-.948.385ZM13.5 5.5h-7v9.75q0 .104.073.177t.177.073h6.5q.083 0 .167-.083.083-.084.083-.167ZM8.333 14h1.084V7H8.333Zm2.25 0h1.084V7h-1.084ZM6.5 5.5v10-.25Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Delete.46bc4a2d.svg";
export { ForwardRef as ReactComponent };